import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormControl, FormLabel, TextField, Stack, CircularProgress } from "@mui/material";

const LinkedinDealFormModal = ({ open, onClose, deal, isCompanyManaged, onSave, isLoading }) => {
  const isEdit = !!deal?.id;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      totalSlots: 1,
      expireDate: "",
      monthlyCreditAmount: 0,
    },
  });

  useEffect(() => {
    if (open) {
      if (isEdit) {
        reset({
          totalSlots: deal.totalSlots || 1,
          expireDate: deal.expireDate && deal.expireDate !== "9999-01-01T00:00:00.000Z" ? deal.expireDate.split("T")[0] : "",
          monthlyCreditAmount: deal.monthlyCreditAmount || 0,
        });
      } else {
        reset({
          totalSlots: 1,
          expireDate: "",
          monthlyCreditAmount: 0,
        });
      }
    }
  }, [open, deal, isEdit, reset]);

  const onSubmit = (data) => {
    const payload = {
      totalSlots: Number(data.totalSlots),
    };

    if (isEdit) {
      payload.id = deal.id;
      payload.status = deal.status;
    }

    if (!isCompanyManaged) {
      payload.expireDate = data.expireDate || "";
      payload.monthlyCreditAmount = Number(data.monthlyCreditAmount) || 0;
    }

    onSave(payload);
  };

  return (
    <Dialog open={open} onClose={() => {}} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>{isEdit ? `Edit Deal #${deal.id}` : "Add New Deal"}</DialogTitle>
      <DialogContent dividers>
        <Stack component="form" id="linkedin-deal-form" onSubmit={handleSubmit(onSubmit)} spacing={2} sx={{ mt: 1 }}>
          <FormControl fullWidth>
            <FormLabel sx={{ mb: 1 }}>Number of Slots</FormLabel>
            <TextField
              size="small"
              type="number"
              {...register("totalSlots", {
                required: "Number of slots is required",
                min: { value: 1, message: "Minimum 1 slot is required" },
              })}
              error={!!errors.totalSlots}
              helperText={errors.totalSlots?.message}
              inputProps={{ min: 1 }}
              disabled={isEdit}
            />
          </FormControl>

          {!isCompanyManaged && (
            <>
              <FormControl fullWidth>
                <FormLabel sx={{ mb: 1 }}>Contract Expiry Date</FormLabel>
                <TextField size="small" type="date" {...register("expireDate")} InputLabelProps={{ shrink: true }} />
              </FormControl>

              <FormControl fullWidth>
                <FormLabel sx={{ mb: 1 }}>Monthly Credit Amount</FormLabel>
                <TextField
                  size="small"
                  type="number"
                  {...register("monthlyCreditAmount", {
                    min: { value: 0, message: "Minimum value is 0" },
                  })}
                  error={!!errors.monthlyCreditAmount}
                  helperText={errors.monthlyCreditAmount?.message}
                  inputProps={{ min: 0 }}
                />
              </FormControl>
            </>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button onClick={onClose} variant="outlined" fullWidth disabled={isLoading}>
          Cancel
        </Button>
        <Button type="submit" form="linkedin-deal-form" variant="contained" fullWidth disabled={isLoading} startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}>
          {isEdit ? "Save Changes" : "Create Deal"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LinkedinDealFormModal;
